function getCsrfSalt(): string {
  const salt = process.env.REACT_APP_CSRF_SALT;
  if (!salt) {
    throw new Error("REACT_APP_CSRF_SALT is not defined");
  }
  return salt;
}

export async function getConsoleCsrfToken() {
  const timestamp = Date.now();
  const token = await generateCsrfToken(timestamp, getCsrfSalt());

  return {
    token,
  };
}

async function generateHash(data: string): Promise<string> {
  const encoder = new TextEncoder();
  const hashBuffer = await crypto.subtle.digest(
    "SHA-256",
    encoder.encode(data),
  );
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}

function createCsrfData(timestamp: number | string, salt: string): string {
  return `${timestamp}.${salt}`;
}

async function generateCsrfToken(
  timestamp: number,
  salt: string,
): Promise<string> {
  const data = createCsrfData(timestamp, salt);
  const hash = await generateHash(data);
  const token = `${timestamp}.${hash}`;
  return btoa(token);
}

/*
// const CSRF_TOKEN_TIMEOUT_SECONDS = 5;

async function validateCsrfToken(
  token: string,
  salt: string,
): Promise<boolean> {
  try {
    const decodedToken = atob(token);
    const [timestamp, originalHash] = decodedToken.split(".");

    const tokenTime = parseInt(timestamp);
    const currentTime = Date.now();

    if (currentTime - tokenTime > CSRF_TOKEN_TIMEOUT_SECONDS * 1000) {
      return false;
    }

    const data = createCsrfData(timestamp, salt);
    const newHash = await generateHash(data);

    return originalHash === newHash;
  } catch {
    // logger.error("Invalid CSRF token");
    return false;
  }
}
*/
